import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { flagPortrait } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import Dropzone from 'react-dropzone';

// Components
import * as icons from '../Icons/Icons';

const PhotoUpload = observer(class PhotoUpload extends React.Component {
  constructor() {
    super();
    this.handleDrop = this.handleDrop.bind(this);
    this.handleDragEnter = this.handleDragEnter.bind(this);
    this.handleDragLeave = this.handleDragLeave.bind(this);
    this.removePhoto = this.removePhoto.bind(this);
  }

  componentWillMount() {
    this.state = {
      dropClass: ''
    }
  }

  handleDrop(file, rejected) {
    const { SessionStore } = this.props.store;
    let size = 0;

    if(file.length === 0) {
      const dialogContent = this.props.translation.invalid;
      SessionStore.showDialog(dialogContent);

      this.setState({
        dropClass: ''
      });
    } else {
      for(let i = 0; i < file.length; i++) {
        size += file[i].size;
      }
    }

    if(this.props.attachment.length + file.length <= 5 && size <= 1048576) {
      this.setState({
        dropClass: ''
      });

      let attachment = [...this.props.attachment.concat(file)];

      console.log(attachment)

      this.props.parent.setState({
        attachment
      })
    } else {
      let dialogContent = this.props.translation.limit;

      if(size > 1048576) {
        dialogContent = this.props.translation.too_large;
      }

      SessionStore.showDialog(dialogContent);

      this.setState({
        dropClass: ''
      });
    }
  }

  handleDragEnter() {
    this.setState({
      dropClass: 'file-drop--drag-enter'
    });
  }

  handleDragLeave() {
    this.setState({
      dropClass: ''
    });
  }

  removePhoto(type) {
    if(type === 'existingImage') {
      this.props.parent.setState({
        oldImage: this.props.existingImage
      });
    }

    this.props.parent.setState({
      [type]: []
    });
  }

  render() {
    const { attachment, translation } = this.props;

    let existingImage = this.props.existingImage;

    if(typeof existingImage === 'undefined') {
      existingImage = [];
    }

    return(
      <div>
        {(!attachment.length && !existingImage.length) &&
          <Dropzone
            className={`file-drop ${this.state.dropClass}`}
            onDrop={this.handleDrop}
            onDragEnter={this.handleDragEnter}
            onDragLeave={this.handleDragLeave}
            multiple={false}
            accept={'image/*'}
          >
            <icons.iconPicture />
            <label className="file-drop__label">{translation.upload_label}</label>
          </Dropzone>
        }

        {attachment.map(
          (photo, i) =>
          <div key={i} className="file-drop__preview">
            <div className="file-drop__preview-wrap">
              <span className="avatar-wrap">
                <img
                  className="avatar"
                  src={photo.preview}
                  alt=""
                  onLoad={(e) => {flagPortrait(e, photo.preview)}}
                />
              </span>

              <button
                className="file-drop__remove"
                onClick={() => {this.removePhoto('attachment')}}
              >
                <icons.iconMinus />
                <span className="meta">{translation.choose_another}</span>
              </button>
            </div>
          </div>
        )}

        {existingImage.map(
          (photo, i) =>
          <div key={i} className="file-drop__preview">
            <div className="file-drop__preview-wrap">
              <span className="avatar-wrap">
                <img
                  className="avatar"
                  src={photo}
                  alt=""
                  onLoad={(e) => {flagPortrait(e, photo)}}
                />
              </span>

              <button
                className="file-drop__remove"
                onClick={() => {this.removePhoto('existingImage')}}
              >
                <icons.iconMinus />
                <span className="meta">{translation.choose_another}</span>
              </button>
            </div>
          </div>
        )}
      </div>
    )
  }
})

export default translate('PhotoUpload')(PhotoUpload);



// WEBPACK FOOTER //
// ./src/app/components/Modules/PhotoUpload.js